import dateformat from 'dateformat'
export default  function(value) {
  return dateformat(value, "dd.mm.yyyy HH.MM")
}
